$(function () {
    $('.banner').each(function () {
        if ($(this).find('.breadcrumb-wrap').length) {
            $(this).addClass('__has-breadcrumb');
        }
    })
});